import React from "react";
import CoursePurchaseRow from "./CoursePurchaseRow";

const CoursePurchasesTable = ({ courses }) => {
  const renderPurchases = () => {
    if (Array.isArray(courses)) {
      if (courses.length === 0) {
        return (
          <tr>
            <td colSpan={2}>No hay cursos registradas.</td>
          </tr>
        );
      }
      return courses.map((course) => (
        <CoursePurchaseRow course={course} key={course.course_id} />
      ));
    }
  };

  return (
    <div className="table-responsive">
      <table className="table border">
        <thead className="bg-light border bold small">
          <tr>
            <td>Contenido</td>
            <td>Acceso</td>
          </tr>
        </thead>
        <tbody>{renderPurchases()}</tbody>
      </table>
    </div>
  );
};

export default CoursePurchasesTable;
